import {IApiEndpoint} from "@localization/siteMap/siteMapInterfaces.ts";
import {ISolicitacao, ISolicitacaoTipo} from "@models/solicitacoes/solicitacoes.ts";
import {IGetSolicitacaoTipoFilter} from "@components/solicitacoes/dto/request/IGetSolicitacaoTipoFilter.ts";
import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {ICreateSolicitacaoDto} from "@components/solicitacoes/dto/input/ICreateSolicitacaoDto.ts";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";
import {ILog} from "@models/seguranca/ILog.ts";
import {IReferenciaLink} from "@components/solicitacoes/dto/models/IReferenciaLink.ts";
import {CreateRefLinkDto} from "@components/solicitacoes/itens/dto/CreateRefLinkDto.ts";
import {ISolicitacaoItemValor} from "@components/solicitacoes/dto/models/ISolicitacaoItemValor.ts";

export const __solicitacoes_endpoints = {
	v2: {
		solicitacao: {
			['transferir']: (data: IDataNoPageDto<{
				idSolicitacao: number,
				idNovoSolicitante: number
			}>): IApiEndpoint<ISolicitacao> => ({
				url: `/api/v2/Solicitacoes/${data.data.idSolicitacao}/solicitante/${data.data.idNovoSolicitante}`,
				method: 'PATCH',
				data: {...data, data: {}}
			}),
			['create']: (data: IDataNoPageDto<ICreateSolicitacaoDto>): IApiEndpoint<ISolicitacao> => ({
				url: '/api/v2/Solicitacoes',
				method: 'POST',
				data: data,
			}),
			['get-valores']: (data: IDataNoPageDto<{ idSolicitacao: number }>): IApiEndpoint<any> => ({
				url: `/api/v2/Solicitacoes/${data.data.idSolicitacao}/valores`,
				method: 'GET'
			}),
			['finalizar-solicitacao']: (data: IDataNoPageDto<{
				idSolicitacao: number
			}>): IApiEndpoint<ISolicitacao> => ({
				url: `/api/v2/Solicitacoes/${data.data.idSolicitacao}/finalizar`,
				method: 'POST',
				data: {...data, data: {}}
			}),
			['get-logs']: (data: IDataDto<{ idSolicitacao: number }>): IApiEndpoint<ILog[]> => ({
				url: `/api/v2/Solicitacoes/${data.data.idSolicitacao}/logs`,
				method: 'GET',
				data: {...data, data: {}},
			}),
			['get-itens']: (data: IDataDto<{
				idSolicitacao: number,
				contaReferencias?: boolean,
				contaOrcamentos?: boolean
			}>): IApiEndpoint<ISolicitacaoItemValor[]> => {
				const {idSolicitacao, ...rest} = data.data

				return ({
					url: `/api/v2/Solicitacoes/${idSolicitacao}/itens`,
					method: 'GET',
					data: {...data, data: rest},
				})
			},
			['get-detalhes']: (data: IDataNoPageDto<{idSolicitacao: number}>): IApiEndpoint<ISolicitacao> => {
				const {idSolicitacao, ...rest} = data.data
				return ({
					url: `/api/v2/Solicitacoes/${idSolicitacao}/detalhes`,
					method: 'GET',
					data: {...data, data: {...rest}},
				})
			}
		},
		itens: {

			['get-referencias']: (data: IDataDto<{ idItem: number }>): IApiEndpoint<IReferenciaLink[]> => ({
				url: `/api/v2/Solicitacoes/itens/${data.data.idItem}/referencias`,
				method: 'GET',
				data: {...data, data: {}},
			}),
			['add-referencia']: (data: IDataNoPageDto<CreateRefLinkDto>): IApiEndpoint => {
				const {idItem, ...rest} = data.data;

				return ({
					url: `/api/v2/Solicitacoes/itens/${idItem}/referencias`,
					method: 'POST',
					data: {...data, data: {...rest}}
				})
			}
		},
		tipo: {
			['get-tipos']: (data: IDataDto<IGetSolicitacaoTipoFilter, 'Forms' |
				'Solicitacoes' |
				'Parametros' |
				'Criador' |
				'Alterador'>): IApiEndpoint<ISolicitacaoTipo[]> => {
				return {
					url: '/api/v2/Solicitacoes/tipos',
					data: data,
					method: 'GET'
				}
			},
			['get-tipo']: (id: number): IApiEndpoint<ISolicitacaoTipo> => ({
				url: `/api/v2/Solicitacoes/tipos/${id}`,
				method: 'GET'
			}),
		},
		orcamento: {
			cancelar: (data: IDataNoPageDto<{
				idOrcamento: number,
				motivo: string
			}>): IApiEndpoint<ISolicitacaoOrcamento> => {
				return {
					url: `/api/v2/Solicitacoes/orcamentos/${data.idOrcamento}/cancelar`,
					method: 'DELETE',
					data: {...data, data: {}},
					query: {motivo: data.motivo}
				}
			},
			confirmar: (data: IDataNoPageDto<{ idOrcamento: number }>): IApiEndpoint<ISolicitacaoOrcamento> => {
				return {
					url: `/api/v2/Solicitacoes/orcamentos/${data.idOrcamento}/confirmar`,
					method: 'POST',
					data: {...data, data: {}},
				}
			},
		}
	}
};
